import React, { useEffect } from "react";
import useMarketStock from "../../hooks/useMarketStock";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import { numberFormat, priceFormat } from "../../exports/UtilFunctions";

const DEVICE_SIZE = getDeviceSize();

function FamilyStocksTableRow({ stock, index, SetIndividualPrice }) {
  const {
    StockCode,
    StockName,
    AverageCost,
    PortfolioWeight,
    CostValue,
    LastClose,
    LastValue,
    CurrentValue,
    Quantity,
    TotalReturn,
    CurrentPrice,
  } = stock;

  const stockData = useMarketStock(StockCode);

  const GetColorClass = (num) => {
    if (parseFloat(num) < 0) {
      return "negative";
    } else {
      return "positive";
    }
  };

  useEffect(() => {
    let last_traded_price = stockData
      ? stockData.last_traded_price
      : CurrentPrice;
    SetIndividualPrice(index, last_traded_price);
  }, [stockData]);

  let prev_close = LastClose;
  let change_price = stockData ? parseFloat(stockData.change_price) : 0;
  let last_traded_price = stockData
    ? stockData.last_traded_price
    : CurrentPrice;
  let change_percentage = (last_traded_price / prev_close - 1) * 100;
  const original_value = parseFloat(LastValue);
  let current_value = Quantity * last_traded_price;
  const investment_cost = Quantity * AverageCost;

  const change_value = current_value - original_value;
  let current_returns = (current_value / CostValue - 1) * 100;

  if (DEVICE_SIZE === "S") {
    return (
      //   <div className="family-stocks-row">
      //     <div className="fs-row">
      //       <div>
      //         <span>{StockCode}</span>
      //       </div>
      //       <div>
      //         <span style={{ fontSize: "13px" }}>
      //           {priceFormat(last_traded_price)}
      //           <span className={change_price > 0 ? "positive" : "negative"}>
      //             &nbsp;&nbsp;
      //             {priceFormat(change_price)}&nbsp; (
      //             {numberFormat(change_percentage)}%)
      //           </span>
      //         </span>
      //       </div>
      //     </div>
      //     <div className="fs-row">
      //       <div>
      //         <p>Inv. Cost(Avg. Cost)</p>
      //         <span>
      //           {priceFormat(investment_cost)}&nbsp; ({priceFormat(AverageCost)})
      //         </span>
      //       </div>
      //       <div>
      //         <p>Inv. Value</p>
      //         <span> {priceFormat(current_value)}</span>
      //       </div>
      //     </div>
      //     <div className="fs-row">
      //       <div>
      //         <p>Quantity</p>
      //         <span>{numberFormat(Quantity)}</span>
      //       </div>
      //       <div>
      //         <p>PnL</p>
      //         <span className={TotalReturn > 0 ? "positive" : "negative"}>
      //           {priceFormat(current_value - investment_cost)} (
      //           {numberFormat(TotalReturn)}%)
      //         </span>
      //       </div>
      //     </div>
      //   </div>

      <div className="family-stocks-row">
        <div className="fs-row-header">
          <div>
            <span>{StockCode}</span>
          </div>
          <div>
            <span> {priceFormat(current_value)}</span>
          </div>
        </div>
        <div className="fs-row">
          <div>
            <span>
              {numberFormat(Quantity)}&nbsp;@&nbsp;{priceFormat(AverageCost)}
            </span>
          </div>
          <div>
            <span>
              {" "}
              <span>
                {priceFormat(last_traded_price)}
                <span className={change_price > 0 ? "positive" : "negative"}>
                  &nbsp;&nbsp;
                  {priceFormat(change_price)}&nbsp; (
                  {numberFormat(change_percentage)}%)
                </span>
              </span>
            </span>
          </div>
        </div>
        <div className="fs-row">
          <div>
            <span>{priceFormat(investment_cost)}&nbsp;</span>
          </div>
          <div>
            <span className={TotalReturn > 0 ? "positive" : "negative"}>
              {priceFormat(current_value - investment_cost)} (
              {numberFormat(TotalReturn)}%)
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <tr>
        <td>
          <div className="stock-name-code">
            <p>{StockCode}</p>
            <span>{StockName}</span>
          </div>
        </td>
        <td>{numberFormat(Quantity, 0)}</td>
        <td>{PortfolioWeight}%</td>
        <td>{priceFormat(AverageCost)}</td>
        <td>{priceFormat(last_traded_price)}</td>
        <td>{priceFormat(CostValue)}</td>
        <td>{priceFormat(current_value)}</td>
        <td className={GetColorClass(current_returns)}>
          {numberFormat(current_returns)}%
        </td>
        <td className={GetColorClass(change_percentage)}>
          {numberFormat(change_percentage)}%
        </td>
      </tr>
    </>
  );
}

export default FamilyStocksTableRow;
